/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
// import "core-js/stable";
// import "regenerator-runtime/runtime";
// import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import { renderRoutes } from 'react-router-config';
import { trigger } from 'redial';
import { createBrowserHistory } from 'history';
import Loadable from 'react-loadable';
import { AppContainer as HotEnabler } from 'react-hot-loader';
import { getStoredState } from 'redux-persist';
import { CookieStorage } from 'redux-persist-cookie-storage';
import Cookies from 'cookies-js';
import createStore from 'redux/create';
import apiClient from 'helpers/apiClient';
import { routes } from './routes/desktop-routes';
import asyncMatchRoutes from 'utils/asyncMatchRoutes';
import ReduxAsyncConnect from 'ReduxAsyncConnect/ReduxAsyncConnect';
import { Provider } from 'react-redux';
import rootSaga from './sagas';
const persistConfig = {
  key: 'root',
  storage: new CookieStorage(Cookies),
  stateReconciler(inboundState, originalState) {
    // Ignore state from cookies, only use preloadedState from window object
    return originalState;
  },
};

const dest = document.getElementById('content');

const client = apiClient();
const providers = {
  client
};

(async () => {
  const preloadedState = await getStoredState(persistConfig);
  const history = createBrowserHistory();
  const store = createStore({
    history,
    data: {
      ...preloadedState,
      ...window.__data
    },
    helpers: providers,
    persistConfig
  });

  store.runSaga(rootSaga);

  const hydrate = async _routes => {

    // sagas.done.then(() => { });
    const { components, match, params } = await asyncMatchRoutes(_routes, history.location.pathname);
    const triggerLocals = {
      ...providers,
      store,
      match,
      params,
      history,
      location: history.location
    };
    if (window.__data) {
      delete window.__data;
    } else {
      await trigger('fetch', components, triggerLocals);
    }
    await trigger('defer', components, triggerLocals);

    ReactDOM.hydrate(
      <HotEnabler>
        <Provider store={store} {...providers}>
          <ConnectedRouter history={history}>
            <ReduxAsyncConnect routes={_routes} store={store} helpers={providers}>
              {renderRoutes(_routes)}
            </ReduxAsyncConnect>
          </ConnectedRouter>
        </Provider>
      </HotEnabler>,
      dest
    );
  };

  await Loadable.preloadReady();

  await hydrate(routes);

  // Hot reload
  if (module.hot) {
    module.hot.accept('./routes/desktop-routes', () => {
      const nextRoutes = require('./routes/desktop-routes');
      hydrate(nextRoutes).catch(err => {
        console.error('Error on routes reload:', err);
      });
    });
  }

  // Server-side rendering check
  if (process.env.NODE_ENV !== 'production') {
    window.React = React; // enable debugger

    if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-reactroot']) {
      console.error('Server-side React render was discarded.\n' +
        'Make sure that your initial render does not contain any client-side code.');
    }
  }

  // Dev tools
  if (__DEVTOOLS__ && !window.devToolsExtension) {
    const devToolsDest = document.createElement('div');
    window.document.body.insertBefore(devToolsDest, null);
    const DevTools = require('./DevTools/DevTools');
    ReactDOM.hydrate(
      <Provider store={store}>
        <DevTools />
      </Provider>,
      devToolsDest
    );
  }

  // Service worker
  if (!__DEVELOPMENT__ && 'serviceWorker' in navigator) {
    try {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.every(reg => {
          if (reg.active && reg.active.scriptURL.indexOf('/sw-desktop-v1.js') === -1) {
            reg.unregister();
          }
          return true;
        });
      });
      navigator.serviceWorker.register('/sw-desktop-v1.js', {
        insecure: true
      }).then(reg => {
        console.log('ServiceWorker registered', reg);
        let updateInterval;
        clearInterval(updateInterval);
        updateInterval = setInterval(() => {
          reg.update();
        }, 1 * 60 * 60 * 1000); /* Check For update in a day */
      }).catch(err => {
        console.log('ServiceWorker not registered', err);
      });
    } catch (error) {
      console.log('Error registering service worker: ', error);
    }
    await navigator.serviceWorker.ready;
    console.log('Service Worker Ready');
  }
})();
